module.exports = __webpack_public_path__ + "static/media/78 - Khruangbin - Texas Sun.ebfae719.mp3";